import ProfilePageContent from "../../components/profile/profileContent";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import RootLayout from "../layout";
import httpService from "../../services/http.service";
import { getAuthApiRoute, getBillingApiRoute } from "../../utils/api.utils";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../redux/Slices/loading.slice";
import PageLayout from "../../components/layout/PageLayout";

const checkAuth = () => localStorage.getItem("webTvUserToken");

const ProfilePage = () => {
  const auth = checkAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (!auth) {
    navigate("/login");
  }

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  async function getProfileInfo() {
    const response = await httpService.get(getAuthApiRoute("user"));

    // Fetch current subscription info with remainingAccessDays
    let currentSubscription = null;
    try {
      const subscriptionResponse = await httpService.get(
        getBillingApiRoute("payment/subscription/current")
      );
      if (subscriptionResponse.status === 200 && subscriptionResponse.data?.data) {
        currentSubscription = subscriptionResponse.data.data;
      }
    } catch (error) {
      console.warn("Could not fetch current subscription:", error);
    }

    if (!response.status === 200) {
      throw new Error(response.data);
    }

    const { data } = response.data;

    return {
      ...data,
      activeSubscription: currentSubscription,
    };
  }

  useEffect(() => {
    // Start loading - disables sidebar navigation
    dispatch(startLoading("در حال بارگذاری پروفایل..."));

    getProfileInfo().then((data) => {
      setData(data);
      setLoading(false);
      // Stop loading - re-enables sidebar navigation
      dispatch(stopLoading());
    }).catch((error) => {
      console.error("Error loading profile:", error);
      setLoading(false);
      dispatch(stopLoading());
    });
  }, []);

  return (
    <RootLayout>
      <PageLayout loading={loading} skeletonType="profile">
        {!loading && data && <ProfilePageContent data={data} />}
      </PageLayout>
    </RootLayout>
  );
};

export default ProfilePage;

